const data = {
  'Selected': 'Đã chọn: {0} trong {1}',
  'Uploading files': 'Đang tải lên {0}% của {1}',
  'File size error': '{0} quá lớn, chỉ được tải lên tệp nhỏ hơn {1}',
  'Upload failed': '{0} tải lên thất bại',
  'Per page': '{0} dòng mỗi trang',
  'Folder': 'Thư mục',
  'Login failed, please try again': 'Đăng nhập thất bại, vui lòng thử lại',
  'Already logged in': 'Bạn đã đăng nhập rồi.',
  'Please enter username and password': 'Vui lòng nhập tên đăng nhập và mật khẩu.',
  'Not Found': 'Không tìm thấy',
  'Not Allowed': 'Không được phép',
  'Please log in': 'Vui lòng đăng nhập',
  'Unknown error': 'Lỗi không xác định',
  'Add files': 'Thêm tệp',
  'New': 'Tạo mới',
  'New name': 'Tên mới',
  'Username': 'Tên đăng nhập',
  'Password': 'Mật khẩu',
  'Login': 'Đăng nhập',
  'Logout': 'Đăng xuất',
  'Profile': 'Tài khoản',
  'No pagination': 'Không phân trang',
  'Time': 'Thời gian',
  'Name': 'Tên',
  'Size': 'Dung lượng',
  'Home': 'Trang chính',
  'Copy': 'Sao chép',
  'Move': 'Di chuyển',
  'Rename': 'Đổi tên',
  'Required': 'Vui lòng điền vào ô này',
  'Zip': 'Nén ZIP',
  'Batch Download': 'Tải gộp',
  'Unzip': 'Giải nén',
  'Delete': 'Xoá',
  'Download': 'Tải về',
  'Copy link': 'Sao chép liên kết',
  'Done': 'Xong',
  'File': 'Tệp',
  'Drop files to upload': 'Thả tệp vào đây để tải lên',
  'Close': 'Đóng',
  'Select Folder': 'Chọn thư mục',
  'Users': 'Người dùng',
  'Files': 'Tệp',
  'Role': 'Vai trò',
  'Cancel': 'Huỷ',
  'Paused': 'Đã tạm dừng',
  'Confirm': 'Xác nhận',
  'Create': 'Tạo',
  'User': 'Người dùng',
  'Admin': 'Quản trị',
  'Save': 'Lưu',
  'Read': 'Đọc',
  'Write': 'Ghi',
  'Upload': 'Tải lên',
  'Permissions': 'Quyền',
  'Homedir': 'Thư mục gốc',
  'Leave blank for no change': 'Để trống nếu không đổi',
  'Are you sure you want to do this?': 'Bạn có chắc chắn muốn thực hiện?',
  'Are you sure you want to allow access to everyone?': 'Bạn có chắc chắn muốn cho phép tất cả mọi người truy cập?',
  'Are you sure you want to stop all uploads?': 'Bạn có chắc chắn muốn dừng toàn bộ việc tải lên?',
  'Something went wrong': 'Đã có lỗi xảy ra',
  'Invalid directory': 'Thư mục không hợp lệ',
  'This field is required': 'Ô này không được để trống',
  'Username already taken': 'Tên đăng nhập đã có người dùng',
  'User not found': 'Không tìm thấy người dùng',
  'Old password': 'Mật khẩu cũ',
  'New password': 'Mật khẩu mới',
  'Wrong password': 'Sai mật khẩu',
  'Updated': 'Đã cập nhật',
  'Deleted': 'Đã xoá',
  'Your file is ready': 'Tệp của bạn đã sẵn sàng',
  'View': 'Xem',
  'Search': 'Tìm kiếm',
  'Download permission': 'Tải về',
  'Guest': 'Khách',
  'Show hidden': 'Hiện tệp ẩn',
  'Show symbolic format': 'Hiện dạng ký hiệu',
  'Hide symbolic format': 'Ẩn dạng ký hiệu',
  'Add folder': 'Tải thư mục lên',
  'successful_failed_total': '{0} thành công, {1} thất bại, {2} tổng cộng',
  'And N more': '... và {0} tệp khác',
  'File conflict title': 'Tệp đã tồn tại',
  'Existing file': 'Tệp đã có',
  'New file': 'Tệp mới',
  'Apply to remaining conflicts': 'Áp dụng cho các xung đột còn lại',
  'Skip': 'Bỏ qua',
  'Keep both': 'Giữ cả hai',
  'Overwrite': 'Ghi đè',
  'Upload limit': 'Giới hạn dung lượng tải lên',
  'Upload limit help': 'Áp dụng cho mọi người dùng. Tệp được tải lên theo từng mảnh nhỏ nên giá trị này có thể lớn hơn giới hạn của PHP.',
  'Current PHP limit': 'Giới hạn hiện tại của PHP mỗi lần gửi: {0}',
  'Value must be at least 1 MB': 'Giá trị phải từ 1 MB trở lên',
  'System log': 'Nhật ký hệ thống',
  'Log truncated notice': 'Chỉ hiện {0} dòng gần nhất. Tải xuống tệp đầy đủ để xem thêm.',
  'Idle logout message': 'Đã tự động đăng xuất do không thao tác trong một thời gian.',
  'Security settings': 'Bảo mật',
  'Idle logout minutes': 'Tự động đăng xuất sau (phút không thao tác)',
  'Idle logout minutes help': 'Áp dụng cho mọi người dùng. Từ 1 đến 120 phút.',
  'Download link lifetime minutes': 'Thời hạn link tải (phút)',
  'Download link lifetime help': 'Link tải vẫn dùng được sau khi đã đăng xuất, tới khi hết hạn này. Từ 1 đến 1440 phút.',
  'Lock download link to IP': 'Chỉ dùng được từ đúng IP đã tạo link',
  'Minutes': 'phút',
  'Link copied': 'Đã sao chép liên kết',
}

export default data
